__turbopack_context__.v({
  "className": "satoshiregular_9602c6c8-module__LnoEjq__className",
  "variable": "satoshiregular_9602c6c8-module__LnoEjq__variable",
});
